/**
 * orga-app-api - veranstaltungen-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AktionDataRequest { 
    titel: string;
    info_text?: string;
    reihenfolge?: number;
    aktion_id: string;
    veranstaltung_id: string;
}

